// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-747dfee8] .el-drawer__header {\n  padding: 20px;\n  margin: 0;\n}\n[data-v-747dfee8] .el-drawer__body {\n  padding: 0px 10px;\n}\n[data-v-747dfee8] .el-tabs .el-tabs__header {\n  margin: 0;\n}\n.content[data-v-747dfee8] {\n  height: calc(100% - 80px);\n}\n.footer[data-v-747dfee8] {\n  height: 40px;\n  line-height: 40px;\n  text-align: right;\n  padding: 0 20px;\n}", ""]);
// Exports
module.exports = exports;
